import instance from "../services/axios";

export const getOperatorsByJobtype = async (jobtypeId: number) => {
  const response = await instance.get(
    `/v1.0/User/GetUsersByJobtype/${jobtypeId}`
  );
  return response.data;
};
